import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";

function DequipoRehabilitacion({ id, onDelete }) {
  const postRemove = async (e) => {
    e.preventDefault();

    try {
      await axios.delete(
        "https://suadesarrollo.azurewebsites.net/api/EliminaEquipoRehabilitacion/" +
          id,
      );

      // ✅ Quita el registro del estado del componente padre
      onDelete(id);

      alert("Eliminado con éxito");
    } catch (error) {
      console.error(error);
      alert("Error al eliminar el registro");
    }
  };

  return (
    <button className="btn btn-danger" onClick={postRemove}>
      <IoIcons.IoIosCloseCircleOutline />
    </button>
  );
}

export default DequipoRehabilitacion;
